//import adotbackground from '../images/adotlogo.png';
import { getEnvVariable } from '../../../../modules/environmentalList';
import adotavatar from '../images/adotavatar.png';
import adotbackground from '../images/ADOTNewLogo.png';
import delasoftlogo from '../images/Delasoft.png';
import DeldotLogo from '../images/deldot.png';
import kytclogo from '../images/kytcicon.jpg';
import Laoacsimage from '../images/Laoacs.jpg';
import oregonlogo from '../images/odoticon.png';
import wisconsin from '../images/wisdot.png';
import woodcountylogo from '../images/WoodCountyLogo.png';
import steeloptlogo from '../images/SteelOptLogo.png';
import { getTokenStorageKey } from '../../tokenKey';

export const getLandingPagelogo = (open = true) => {
    // Check if headerImage is defined in environment config
    const headerImage = getEnvVariable('headerImage')
    if (headerImage) {
        return headerImage
    }
    
    let right = (localStorage.getItem(getTokenStorageKey())) ? RightDrawerAvatar() : false
    let key = getEnvVariable('ModuleKey')
    switch (key) {
        case 'KEPT':
            return kytclogo
        case 'AMES':
            return oregonlogo
        case 'MPS':
        case 'APPS':
            return steeloptlogo
        case 'AEPS':
            return (right && open) ? adotbackground : !open ? adotavatar : adotbackground
        case 'WRS':
            return wisconsin
        case 'SHAPES':
            return wisconsin
        case 'UPS':
            return DeldotLogo
        case 'LAOACS':
            return Laoacsimage
        default: return delasoftlogo
    }
}


export const RightDrawerAvatar = () => {
    let key = getEnvVariable('ModuleKey')
    switch (key) {
        case 'AEPS':
        case 'WRS':
            return true
        default: return false
    }
}

//Condition for Hiding Modules for External
export const hideForSubmodules = (key) => {
    switch (key) {
        case 'STATEPROJECTS':
            return true
        case 'VIOLATIONS':
            return true
        case 'JUNKYARDS':
            return true
        case 'TRANSFER':
            return true
        default: return false
    }
}